// /metric_preferences client. Mirrors middleware/routes/metric_preferences.py.

import { api } from "./base";

export interface MetricPreference {
  id: number;
  organization: string;
  metric_phrase: string;
  description: string | null;
  rewritten_query: string;
  datasource: string | null;
  created_by: string;
  created_at: string | null;
  updated_at: string | null;
}

async function jsonFetch<T>(bearer: string, url: string, init?: RequestInit): Promise<T> {
  const resp = await fetch(url, {
    ...init,
    headers: {
      ...(init?.headers ?? {}),
      Authorization: `Bearer ${bearer}`,
      ...(init?.body ? { "Content-Type": "application/json" } : {}),
    },
  });
  if (!resp.ok) {
    const text = await resp.text().catch(() => "");
    throw new Error(`${init?.method ?? "GET"} ${url} → ${resp.status}: ${text}`);
  }
  return (await resp.json()) as T;
}

export function listMetricPreferences(bearer: string, organization: string): Promise<MetricPreference[]> {
  return jsonFetch<MetricPreference[]>(bearer, `${api("/metric_preferences")}?organization=${encodeURIComponent(organization)}`);
}

export interface SaveMetricArgs {
  organization: string;
  metric_phrase: string;
  description: string;
  rewritten_query: string;
  original_query?: string;
  datasource?: string;
}

export function saveMetricPreference(bearer: string, args: SaveMetricArgs): Promise<{ ok: true; metric_phrase: string }> {
  return jsonFetch(bearer, `${api("/metric_preferences")}`, { method: "POST", body: JSON.stringify(args) });
}

export async function deleteMetricPreference(bearer: string, id: number): Promise<void> {
  await jsonFetch<{ ok: true }>(bearer, `${api("/metric_preferences")}/${id}`, { method: "DELETE" });
}
